module.exports = __webpack_public_path__ + "static/media/icon_bullet_active.ec60cada.svg";